(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('hasFeature', ['$rootScope', 'OrganizationSettings', function hasFeature($rootScope, OrganizationSettings) {
    function showIfFeature($element, featureName) {
      if (OrganizationSettings.hasFeature(featureName)) {
        $element.show();
      } else {
        $element.hide();
      }
    }
    return function ($scope, $element, $attr) {
      showIfFeature($element, $attr.hasFeature);

      // When organization changes, re-init
      var cleanupHandler = $rootScope.$on('organization-selected', function () {
        showIfFeature($element, $attr.hasFeature);
      }, true);
      $scope.$on("$destroy", function () {
        cleanupHandler();
      });
    };
  }]).directive('lacksFeature', ['$rootScope', 'OrganizationSettings', function lacksFeature($rootScope, OrganizationSettings) {
    function showIfLacksFeature($element, featureName) {
      if (!OrganizationSettings.hasFeature(featureName)) {
        $element.show();
      } else {
        $element.hide();
      }
    }
    return function ($scope, $element, $attr) {
      showIfLacksFeature($element, $attr.lacksFeature);

      // When organization changes, re-init
      var cleanupHandler = $rootScope.$on('organization-selected', function () {
        showIfLacksFeature($element, $attr.hasFeature);
      }, true);
      $scope.$on("$destroy", function () {
        cleanupHandler();
      });
    };
  }]);
})();
